import sessionFlag from "./session_flag"

// Shared by payroll_run_channel.js and payroll_sheet_errors_channel.js, which
// both need to show this alert at most once per run per browser session.
const flag = sessionFlag('salaryOperationFailureAlertShown');

// The legacy (non-itemized) flow's own salary_operation broadcast carries no
// payrollRunId at all (see SalaryOperationsWorker), so it can't be tracked by
// the per-run sessionStorage flag below — window.salaryOperationFailureAlertShown
// is reserved for that ID-less case only. A real payrollRunId always goes
// through the per-run flag, so one run's failure can no longer suppress a
// distinct run's own alert in the same tab.
export const salaryOperationFailureAlertShown = (payrollRunId) => {
  if (!payrollRunId) return window.salaryOperationFailureAlertShown === true;

  return flag.isSet(payrollRunId);
};

export const markSalaryOperationFailureAlertShown = (payrollRunId) => {
  if (!payrollRunId) {
    window.salaryOperationFailureAlertShown = true;
    return;
  }

  flag.set(payrollRunId);
};
